import React from 'react';
import { render } from 'react-dom';

import { Box, Button, CssBaseline, Typography } from '@material-ui/core';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import { theme, vsafe_name } from '@/client/constants/cdc';
import Liff from '@/client/utils/liff';

if (module.hot) {
  module.hot.accept();
}

const muiTheme = createMuiTheme(theme);

const VsafeRouter = () => (
  <Box display="flex" flexDirection="column" padding={3}>
    <Typography variant="h6" align="center" style={{ lineHeight: 1.2 }}>
      {vsafe_name} COVID-19疫苗接種-健康回報已達階段性任務，爰停止相關健康回報作業，感謝您對健康回報之支持。
    </Typography>
    <Button
      color="primary"
      style={{ marginTop: 40 }}
      onClick={() => {
        Liff.closeWindow();
      }}
    >
      關閉
    </Button>
  </Box>
);

render(
  <MuiThemeProvider theme={muiTheme}>
    <CssBaseline />
    <VsafeRouter />
  </MuiThemeProvider>,
  document.getElementById('root'),
);
